import z from "zod";

export const caseTabsSchema = z.enum([
  "base-info",
  "related-cases",
  "monitoring",
  "supervision",
  "proceeding",
  "deadlines",
  "solver",
  "subjects",
  "file",
  "record",
  "submission-forwarding",
  "cooperation",
  "task",
  "possible-complaint",
  "history",
]);
